// extracted by mini-css-extract-plugin
export default {"popular-section":"PopularServices_popular-section__-nW5x","services-wrapper":"PopularServices_services-wrapper__2aOrG","inner-wrapper":"PopularServices_inner-wrapper__1Vx8s"};